export default () => ({
  root: {},
  material: {
    marginBottom: '2px',
  }
});
